import {
  initMap,
  displayIndustryMarker,
  displayLogisticMarkers,
  displayRegionBoundaries,
} from "./map.js";
import { initUi } from "./ui.js";

/**
 * Initializes the single location map feature.
 */
export function initSingleLocationMap() {
  const mapContainer = document.getElementById("osm-single-wrapper");
  if (!mapContainer) {
    return; // Don't run if the map container isn't on the page
  }

  const locationId = mapContainer.dataset.location;
  const regions = mapContainer.dataset.regions;

  if (!locationId) {
    console.error("Single location map requires a location ID.");
    return;
  }

  // Initialize all components
  initMap("osm-single-wrapper");
  initUi();

  // Fetch and display all map data
  displayIndustryMarker(locationId);
  displayLogisticMarkers();
  displayRegionBoundaries(regions);
}

// Default export for backward compatibility
export default initSingleLocationMap;
